import VideoIntersection from '../components/videoIntersection';
import MediaQuery from 'react-responsive';
import Key8Mobile from '../components/keys/key8mobile';
import Key9 from '../components/keys/key9';
import Key10 from '../components/keys/key10';
const legalVideo = '/ReactAssets/CustomerJourney/LEGAL_MAIN.mp4';
const choicesVideo = '/ReactAssets/CustomerJourney/CHOICES.mp4';
const loadingPoster = '/ReactAssets/CustomerJourney/loading.gif';
function LegalBit({ animate }) {
   return (
      <>
         <div className="flex legalbit">
            <div className="col-1/2">
               <MediaQuery minWidth={768}>
                  <Key9 animate={animate} />
               </MediaQuery>
            </div>
            <div className="col-1/2">
               <VideoIntersection 
               animate={animate} 
               poster={loadingPoster}
               src={legalVideo} 
               loop />
               <div className="content">
                  <h2>The legal bit</h2>
                  <p>
                     After you’ve reserved your new home, your solicitor will go
                     through everything with you and make it all legally
                     binding. This is when you’ll pay your deposit. You may know
                     it as Exchange of Contracts (in England) or Conclusion of
                     Missives (in Scotland). Remember, we are here at any time
                     if you have any questions.
                  </p>
               </div>
            </div>
         </div>
         <div className="flex dreamchoices">
            <div className="col-1/2">
               <VideoIntersection 
               animate={animate} 
               poster={loadingPoster}
               src={choicesVideo} 
               loop />
            </div>
            <div className="col-1/2">
               <div className="content">
                  <h2>Your home, your dream choices</h2>
                  <p>
                     Another exciting milestone in your journey, it’s time to
                     select the choices for your new home using our Options
                     Visualiser.
                  </p>
                  <br />
                  <p>
                     Using the visualiser in the comfort of your own home,
                     you’ll probably have already selected what you like and how
                     much you want to spend to make your home your own. At your{' '}
                     <strong>Options Meeting</strong>, you’ll be
                     invited to spend some time in the options area in our sales
                     centre, where you can see the full range of finishes
                     available and discuss your plans with our experienced team,
                     who will guide you the rest of the way.
                  </p>
                  <br />
                  <p>
                     The earlier in the build process that you reserve, the
                     wider the range of options and extras you can choose from
                     to make your home feel like yours, from the day you move
                     in. Your new home is starting to take shape!
                  </p>
               </div>
            </div>
            <MediaQuery maxWidth={767}>
               <Key8Mobile animate={animate} />
            </MediaQuery>
            <MediaQuery minWidth={768}>
               <Key10 animate={animate} />
            </MediaQuery>
         </div>
      </>
   );
}

export default LegalBit;
